import { FechamentoMarcacao } from "../marcacao/fechamento-marcacao";
import { MarcacaoConsultaPK } from "../marcacao/marcacao-consulta/pks/marcacao-consulta-pk";
import { MarcacaoPK } from "../marcacao/marcacao-procedimento/pks/marcacao-pk";
import { MotivoCancelamentoMarcacao } from "../marcacao/motivo-cancelamento-marcacao";
import { Util } from "../util/util";

export class MarcacaoDTO {

    idTitular: number | undefined;

    idFilial: number | undefined;

    idPaciente: number | undefined;

    idMedico: number | undefined;

    idMedicoSolicitante: number | undefined;

    dataMarcacao: Date | undefined;

    horaAtendimento: string | undefined;

    dilataPupila: boolean | undefined;

    status: string | undefined;

    nomeFilial: string | undefined;

    nomePaciente: string | undefined;

    nomeMedico: string | undefined;

    nomeMedicoSolicitante: string | undefined;

    nomePacienteTitular: string | undefined;

    cpf: string | undefined;

    cpfTitular: string | undefined;

    dataNascimento: Date | undefined;

    idPlanoSaude: number | undefined;

    nomePlanoSaude: string | undefined;

    foneResidencial: string | undefined;

    foneCelular: string | undefined;

    foneResidencialTitular: string | undefined;

    foneCelularTitular: string | undefined;

    idProcedimento: number | undefined;

    nomeProcedimento: string | undefined;

    idProcedimentoConsulta: number | undefined;

    nomeProcedimentoConsulta: string | undefined;

    pacienteMarcado: string | undefined;

    pacienteMarcadoOutroProcedimento: string | undefined;

    totalMarcado: number | undefined;

    cobrarProcedimento: boolean | undefined;

    portadorNecessidade: boolean | undefined;

    indPeriodoVolta: boolean | undefined;

    idUserMarcacao: number | undefined;

    nameUserMarcacao: string | undefined;

    loginUserMarcacao: string | undefined;

    tipoInconsistencia: string | undefined;

    indTitular: string | undefined;

    fechamentoMarcacao: FechamentoMarcacao | undefined;

    motivoCancelamentoMarcacao: MotivoCancelamentoMarcacao | undefined;

    selected: boolean = false;

    constructor() {
    }

    getIconeStatusMarcacao(): string {

        return Util.getIconeStatusMarcacao(this.status);
    }

    getCorStatusMarcacao(): string {

        return Util.getCorStatusMarcacao(this.status);
    }

    getTooltipStatusMarcacao(): string {

        return Util.getTooltipStatusMarcacao(this.status);
    }

    getIconeCobrarAtendimento(): string {

        return Util.getIconeCobrarAtendimento(this.cobrarProcedimento);
    }

    getCorCobrarAtendimento(): string {

        return Util.getCorCobrarAtendimento(this.cobrarProcedimento);
    }

    getTooltipCobrarAtendimento(): string {

        return Util.getTooltipCobrarAtendimento(this.cobrarProcedimento);
    }

    getIconePNE(): string {

        return Util.getIconePNE(this.portadorNecessidade);
    }

    getCorPNE(): string {

        return Util.getCorPNE(this.portadorNecessidade);
    }

    getTooltipPNE(): string {

        return Util.getTooltipPNE(this.portadorNecessidade);
    }

    getIconePeriodoVolta(): string {

        return Util.getIconePeriodoVolta(this.indPeriodoVolta);
    }

    getCorPeriodoVolta(): string {

        return Util.getCorPeriodoVolta(this.indPeriodoVolta);
    }

    getTooltipPeriodoVolta(): string {

        return Util.getTooltipPeriodoVolta(this.indPeriodoVolta);
    }

    getPkConsultaDaEntidade(): MarcacaoConsultaPK {

        const pk: MarcacaoConsultaPK = new MarcacaoConsultaPK();
        if (this.idFilial) {
            pk.idFilial = this.idFilial;
        }

        if (this.idPaciente) {
            pk.idPaciente = this.idPaciente;
        }

        if (this.idPlanoSaude) {
            pk.idPlanoSaude = this.idPlanoSaude;
        }

        if (this.dataMarcacao) {
            pk.dataMarcacaoConsulta = this.dataMarcacao;
        }

        if (this.idProcedimentoConsulta) {
            pk.idProcedimentoConsulta = this.idProcedimentoConsulta;
        }

        return pk;
    }

    get pkConsultaDaEntidadeConcatenada(): string {

        let pkEntidadeConcatenada: string = '';

        let pkEntidade: MarcacaoConsultaPK = this.getPkConsultaDaEntidade();

        if (pkEntidade) {
            pkEntidadeConcatenada = pkEntidade.idFilial + Util.SEPARADOR +
                pkEntidade.idPaciente + Util.SEPARADOR +
                pkEntidade.idPlanoSaude + Util.SEPARADOR +
                pkEntidade.dataMarcacaoFormatada() + Util.SEPARADOR +
                pkEntidade.idProcedimentoConsulta;
        }

        return pkEntidadeConcatenada;
    }

    getPkProcedimentoDaEntidade(): MarcacaoPK {

        const pk: MarcacaoPK = new MarcacaoPK();
        if (this.idFilial) {
            pk.idFilial = this.idFilial;
        }

        if (this.idPaciente) {
            pk.idPaciente = this.idPaciente;
        }

        if (this.idPlanoSaude) {
            pk.idPlanoSaude = this.idPlanoSaude;
        }

        if (this.dataMarcacao) {
            pk.dataMarcacao = this.dataMarcacao;
        }

        if (this.idProcedimento) {
            pk.idProcedimento = this.idProcedimento;
        }

        return pk;
    }

    get pkProcedimentoDaEntidadeConcatenada(): string {

        let pkEntidadeConcatenada: string = '';

        let pkEntidade: MarcacaoPK = this.getPkProcedimentoDaEntidade();

        if (pkEntidade) {
            pkEntidadeConcatenada =
                pkEntidade.idPaciente + Util.SEPARADOR +
                pkEntidade.idPlanoSaude + Util.SEPARADOR +
                pkEntidade.dataMarcacaoFormatada() + Util.SEPARADOR +
                pkEntidade.idProcedimento;
        }

        return pkEntidadeConcatenada;
    }

    get dilataPupilaFormatado(): string {

        return (this.dilataPupila ? 'SIM' : 'NÃO');
    }
}
